import Joi from "joi-browser";

const ClassifierGroup = Joi.object().keys({
    name: Joi.string().trim().required().label("Name"),
    description: Joi.string().trim().allow([null, ""]).label("Description"),
});

const ClassifierLabels = Joi.array().items(
    Joi.object().keys({
        label: Joi.string().trim().required().label("Label"),
        value: Joi.number().integer().required().label("Value"),
    })
);

const CreateClassifierLabel = Joi.object().keys({
    label: Joi.string().trim().required().label("English Label"),
    value: Joi.number().integer().required().label("Value"),
});

export default {
    ClassifierGroup,
    ClassifierLabels,
    CreateClassifierLabel,
};
